import { RegisterForm } from "@/components/auth";

export const RegisterPage = () => {
  return (
    <div className="flex-row flex-grow justify-center my-auto">
      <div className="flex flex-row justify-center">
        <div className="border-2 shadow-lg p-8 bg-white rounded-xl">
          Welcome! Register below.
          <div className="mt-4">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  );
};
